import React, { useEffect } from 'react'
import { ConversationFeed } from '../zStyling.styled'
import { useDispatch, useSelector } from 'react-redux'
import ConversationItem from '../ConversationItem'
import { getPrayselyConversations } from 'features/messenger/conversationSlice'
import Loader from '../../../loaders/Loader'  
import { imageDefaults } from 'components/utils/imageDefaults' 
import ChurchThreadList from '../churchThread/ChurchThreadList'

export default function ConversationsFeed() {

    const dispatch = useDispatch() 
    const { conversations, getConversationsStatus } = useSelector(state => state.conversations)
    const { isMyProfileLoading } = useSelector((state) => state.profile) 
 
    useEffect(() => { 
        if(conversations.length === 0) {
            dispatch(getPrayselyConversations({ 
                limit: 20,
                cursor: null
            }))
        }
    }, [ ] )


    return (
 
        <ConversationFeed>
            <ChurchThreadList />
            {
                getConversationsStatus === "LOADING" || isMyProfileLoading?
                (
                    <Loader />
                )
                : getConversationsStatus === "SUCCESS" && conversations.length > 0  &&
                (  

                    conversations.map((ele) => (
                        <ConversationItem key={ele._id}
                            conversationId={ele._id}
                            image={ele.otherParticipant.profileImg ? ele.otherParticipant.profileImg.url : imageDefaults.avatar}
                            fullName={ele.otherParticipant.fullName}
                            date={ele.updatedAt}
                            lastMessage={ele.lastMessageText}
                            isUnread={ele.isUnread}
                            otherUserId={ele.otherParticipant._id ?? ele.otherParticipant.id}
                            /> 
                    ))
                    
                )
            }  
        </ConversationFeed>
    )
}

